import { render, staticRenderFns } from "./consultation-info.vue?vue&type=template&id=3b85330f&scoped=true&"
import script from "./consultation-info.vue?vue&type=script&lang=js&"
export * from "./consultation-info.vue?vue&type=script&lang=js&"
import style0 from "./consultation-info.vue?vue&type=style&index=0&id=3b85330f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b85330f",
  null
  
)

export default component.exports